<footer [class]="config.footerClass" data-tfa="pegase-footer" role="contentinfo">
  <div [class.footer-apprenant-links]="config.reducedFooter"
       [id]="config.reducedFooter ? null : 'footer-left-content'">
    <ng-content></ng-content>
  </div>
  @if (config.reducedFooter) {
    <div class="footer-apprenant-copyright">&copy; {{ currentYear }} Pégase</div>
  } @else {
    <div id="footer-right-content">
      <lib-pegase-chip-environement></lib-pegase-chip-environement>
      <span>{{ version }}</span>
      <span>
        <mat-icon
          aria-hidden="false"
          aria-label="Homologation sécurité"
          data-tfa="security"
        >security</mat-icon
        >
      </span>
    </div>
  }
</footer>
